import { BreadcrumbItem } from '@celebration/react/ClbBreadcrumb/ClbBreadcrumb.types';
import { useTranslation } from 'react-i18next';
import { ClbLoading } from '@celebration/react';
import Subheader from '../../../common/components/subheader';
import i18n from '../../../lib/i18n';
import HomeConstants from '../../home/constants';
import RoundsConstants from './constants';
import OffersList from './components/offers-list/offers-list';
import OffersListByPosition from './components/offers-list-by-position/offers-list-by-position';
import RoundInfo from './components/round-info/round-info';
import OffersRoundContext from '../../../app/contexts/offers-round';
import './rounds.scss';
import OfferFilter from './components/offer-filters/offer-filters';
import ConnectionError from '../../../common/components/connection-error/connection-error';
import ErrorModal from '../../../common/components/error-modal';

function RoundsPageContent() {
    const { roundState, isConflictModalOpen, closeConflictModal } =
        OffersRoundContext.useOffersRound();
    const { t } = useTranslation();

    const breadcrumbList: BreadcrumbItem[] = [
        { label: HomeConstants.PAGE_TITLE, url: HomeConstants.PATH },
        {
            label: i18n.t(RoundsConstants.PAGE_TITLE),
            url: RoundsConstants.PATH,
        },
    ];

    return (
        <>
            <Subheader
                title={i18n.t(
                    'SmartCargas.Rounds.AcceptConfirmationManagement',
                )}
                breadcrumbList={breadcrumbList}
                dataTestid="smartcargas-rounds-subheader"
            >
                <RoundInfo />
            </Subheader>

            <OfferFilter />

            {roundState.currentPhase === 'Acceptance' && <OffersList />}
            {roundState.currentPhase === 'Confirmation' && (
                <OffersListByPosition />
            )}

            {roundState.currentPhase === null && <ClbLoading />}

            <ConnectionError />

            <ErrorModal
                isOpen={isConflictModalOpen}
                title={t('ErrorModalTitle')}
                description={t('ErrorModalDescription')}
                onClose={closeConflictModal}
            />
        </>
    );
}

export default function RoundsPage() {
    return (
        <OffersRoundContext.OffersRoundProvider>
            <RoundsPageContent />
        </OffersRoundContext.OffersRoundProvider>
    );
}
